module.exports = __webpack_public_path__ + "assets/img/d5721af4db8b461cdd11f28cf2c84d22.svg";